module.exports = __webpack_public_path__ + "img/about.29df6dd.webp";